export function RefundInfo({ step, setStep }) {
  return (
    <div className='w-full h-[80dvh] flex flex-col items-center justify-center'>
      <div className='max-w-lg max-sm:w-11/12 flex flex-col items-center shadow-lg rounded-md p-8 gap-4'>
        <p className='text-lg font-semibold text-center'>Refund Calculated</p>
        <p className='text-center'>Your refund has been officially calculated. Congratulations!</p>
        <p className='text-center'>Please click "Next" to proceed.</p>
        <div className='flex justify-center w-full'>
          <button
            onClick={() => setStep(step + 1)}
            className='px-8 py-2 text-white rounded bg-primaryColor hover:bg-primaryDarkColor transition duration-200'>
            Next
          </button>
        </div>
      </div>
    </div>
  )
}